export const SET_WAITING = 'SET_WAITING';
export const SET_RESULT = 'SET_RESULT';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';
export const SET_ACTIVE_COUNT = 'SET_ACTIVE_COUNT';
export const SET_SOLD_COUNT = 'SET_SOLD_COUNT';